import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/privacy-policy";

import { brand } from "@/config/brand";
const SITE_URL = brand.url;
const OG_IMAGE = `${SITE_URL}/__l5e/assets-v1/aabeccab-688e-44b7-96b1-aaf70d6a2a8d/social-share-cover.png`;
const DESC =
  "Digitally Baffled's privacy policy for our website and mobile app. How we collect, use, and protect your personal data in accordance with UK GDPR.";

export const Route = createFileRoute("/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy | Digitally Baffled" },
      { name: "description", content: DESC },
      { property: "og:site_name", content: "Digitally Baffled" },
      { property: "og:title", content: "Privacy Policy — Digitally Baffled" },
      { property: "og:description", content: DESC },
      { property: "og:url", content: `${SITE_URL}/privacy-policy` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Privacy Policy — Digitally Baffled" },
      {
        name: "twitter:description",
        content:
          "How we collect, use, and protect your personal data in accordance with UK GDPR.",
      },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/privacy-policy` }],
  }),
  component: Page,
});
